import Tools from "../Tools";
import ad_configure from "../vo/dbvo/ad_configure";
import ad_template from "../vo/dbvo/ad_template";

export type InputGetOneAdvertisement = {
    /**
     * 广告刷新签名
     */
    RefreshSignature?: string;
    /**
     * 设备ID
     */
    DeviceUniqueIdentifier?: string;
};

export type InputBindAdToTopic = {
    AdUniqueIdentifier: string;
    TopicUniqueIdentifier: string;
    order_by_desc: number;
};

/**
 * 创建广告结构体
 */
export type InputCreateOrUpdateAd = {
    /**
     * 要修改的广告唯一标识
     */
    AdUniqueIdentifier?: string;
    ADName: string;
    /**
     * 上传的缩略图
     */
    Thumbnail?: File,
    TempUniqueIdentifier: string;
    AdStartDate: string;
    AdEndDate: string;
    LimitStartTime: string;
    LimitEndTime: string;
    Remarks: string;
};

/**
 * 广告分发相关API
 */
export default class AdvertisementDistributeApi {
    /**
     * 获取一个广告(广告机使用)
     * @param input 
     * @returns 
     */
    public GetOneAdvertisementAsync(input: InputGetOneAdvertisement) {
        return Tools.FetchAsync<{
            RefreshSignature: string,
            HasNextAD: boolean
        }>("AdvertisementDistribute/GetOneAdvertisement", input, "POST");
    }

    /**
     * 投放(绑定)广告到主题
     * @param input 
     */
    public BindAdToTopicAsync(input: InputBindAdToTopic) {
        return Tools.FetchAsync("AdvertisementDistribute/BindAdToTopic", input, "POST");
    }

    /**
     * 创建自定义广告
     */
    public CreateAdAsync(input: InputCreateOrUpdateAd) {
        return Tools.FetchAsync("AdvertisementDistribute/CreateAd", input, "POST", "multipart/form-data");
    }

    /**
     * 修改自定义广告
     * @param input 
     */
    public UpdateAdAsync(input: InputCreateOrUpdateAd) {
        return Tools.FetchAsync("AdvertisementDistribute/UpdateAd", input, "PUT", "multipart/form-data");
    }

    /**
     * 获取我的广告列表
     * @param page 
     * @param pageSize 
     */
    public GetMyAdvertisementListAsync(page: number, pageSize: number) {
        return Tools.FetchAsync<{
            allcount: number,
            pagecount: number,
            data: (ad_configure & { template?: ad_template })[]
        }>("AdvertisementDistribute/GetMyAdvertisementList", {
            page,
            pageSize
        }, "GET");
    }
}